import type { Translations } from '../../types'

const auditLogsMessages: Translations = {
  "auditLogs.eyebrow": "Operativita",
  "auditLogs.title": "Audit log",
  "auditLogs.subtitle": "Tracciamento eventi sensibili e operazioni amministrative.",
  "auditLogs.actions.refresh": "Aggiorna",
  "auditLogs.actions.refreshing": "Aggiornamento...",
  "auditLogs.filters.searchLabel": "Ricerca",
  "auditLogs.filters.searchPlaceholder": "Cerca per azione, utente, request id o IP",
  "auditLogs.filters.sourceLabel": "Sorgente",
  "auditLogs.filters.source.all": "Tutte",
  "auditLogs.filters.source.auth": "Auth service",
  "auditLogs.filters.source.payments": "Payment settings",
  "auditLogs.filters.source.cms": "CMS",
  "auditLogs.filters.source.catalog": "Catalogo",
  "auditLogs.filters.source.orders": "Ordini",
  "auditLogs.filters.outcomeLabel": "Esito",
  "auditLogs.filters.outcome.all": "Tutti",
  "auditLogs.filters.outcome.success": "Successo",
  "auditLogs.filters.outcome.failure": "Errore",
  "auditLogs.filters.outcome.denied": "Negato",
  "auditLogs.stats.total": "Eventi",
  "auditLogs.stats.success": "Successi",
  "auditLogs.stats.failure": "Errori",
  "auditLogs.stats.denied": "Negati",
  "auditLogs.loading": "Caricamento audit log...",
  "auditLogs.empty": "Nessun evento trovato con i filtri correnti.",
  "auditLogs.errors.load": "Errore recupero audit log",
  "auditLogs.pagination.summary": "{{start}}-{{end}} di {{total}} (pagina {{page}}/{{totalPages}})",
  "auditLogs.pagination.previous": "Precedente",
  "auditLogs.pagination.next": "Successiva",
  "auditLogs.table.timestamp": "Timestamp",
  "auditLogs.table.service": "Servizio",
  "auditLogs.table.action": "Azione",
  "auditLogs.table.outcome": "Esito",
  "auditLogs.table.actor": "Attore",
  "auditLogs.table.details": "Dettagli",
  "auditLogs.detailsPanel.title": "Dettaglio evento selezionato",
  "auditLogs.detailsPanel.empty": "Seleziona una riga dalla lista per vedere i dettagli completi dell'evento.",
  "auditLogs.detailsView.subtitle": "Vista dettaglio evento",
  "auditLogs.detailsView.back": "Torna alla lista",
  "auditLogs.fields.noActor": "Sistema",
  "auditLogs.fields.none": "Nessuno",
  "auditLogs.details.changed": "Campi modificati",
  "auditLogs.details.cleared": "Campi azzerati",
  "auditLogs.details.reason": "Motivo",
  "auditLogs.details.requestId": "Request ID",
  "auditLogs.details.ip": "IP",
  "auditLogs.outcome.success": "Successo",
  "auditLogs.outcome.failure": "Errore",
  "auditLogs.outcome.denied": "Negato",
  "auditLogs.outcome.unknown": "Sconosciuto",
  "auditLogs.source.auth": "Auth",
  "auditLogs.source.payments": "Pagamenti",
  "auditLogs.source.cms": "CMS",
  "auditLogs.source.catalog": "Catalogo",
  "auditLogs.source.orders": "Ordini",
  "auditLogs.actions.admin_capability_created": "Capability admin creata",
  "auditLogs.actions.admin_capability_updated": "Capability admin aggiornata",
  "auditLogs.actions.admin_capability_deleted": "Capability admin eliminata",
  "auditLogs.actions.admin_role_created": "Ruolo admin creato",
  "auditLogs.actions.admin_role_updated": "Ruolo admin aggiornato",
  "auditLogs.actions.admin_role_deleted": "Ruolo admin eliminato",
  "auditLogs.actions.admin_section_created": "Sezione admin creata",
  "auditLogs.actions.admin_section_updated": "Sezione admin aggiornata",
  "auditLogs.actions.admin_section_deleted": "Sezione admin eliminata",
  "auditLogs.actions.admin_user_created": "Utente admin creato",
  "auditLogs.actions.admin_user_updated": "Utente admin aggiornato",
  "auditLogs.actions.admin_user_deleted": "Utente admin eliminato",
  "auditLogs.actions.catalog_category_created": "Categoria catalogo creata",
  "auditLogs.actions.catalog_category_updated": "Categoria catalogo aggiornata",
  "auditLogs.actions.catalog_category_deleted": "Categoria catalogo eliminata",
  "auditLogs.actions.catalog_product_created": "Prodotto catalogo creato",
  "auditLogs.actions.catalog_product_updated": "Prodotto catalogo aggiornato",
  "auditLogs.actions.catalog_product_deleted": "Prodotto catalogo eliminato",
  "auditLogs.actions.cms_page_created": "Pagina CMS creata",
  "auditLogs.actions.cms_page_updated": "Pagina CMS aggiornata",
  "auditLogs.actions.cms_page_deleted": "Pagina CMS eliminata",
  "auditLogs.actions.cms_page_translation_created": "Traduzione pagina CMS creata",
  "auditLogs.actions.email_settings_decrypt_success": "Decifratura impostazioni email riuscita",
  "auditLogs.actions.email_settings_decrypt_denied": "Decifratura impostazioni email negata",
  "auditLogs.actions.email_settings_decrypt_failed": "Decifratura impostazioni email fallita",
  "auditLogs.actions.email_settings_read_failed": "Lettura impostazioni email fallita",
  "auditLogs.actions.email_settings_updated": "Impostazioni email aggiornate",
  "auditLogs.actions.email_settings_update_failed": "Aggiornamento impostazioni email fallito",
  "auditLogs.actions.orders_item_cancellation_updated": "Cancellazione item ordine aggiornata",
  "auditLogs.actions.orders_status_updated": "Stato ordine aggiornato",
  "auditLogs.actions.payment_settings_decrypt_success": "Decifratura impostazioni pagamento riuscita",
  "auditLogs.actions.payment_settings_decrypt_denied": "Decifratura impostazioni pagamento negata",
  "auditLogs.actions.payment_settings_decrypt_failed": "Decifratura impostazioni pagamento fallita",
  "auditLogs.actions.payment_settings_read_failed": "Lettura impostazioni pagamento fallita",
  "auditLogs.actions.payment_settings_update_denied": "Aggiornamento impostazioni pagamento negato",
  "auditLogs.actions.payment_settings_updated": "Impostazioni pagamento aggiornate",
  "auditLogs.actions.stripe_checkout_session_created": "Sessione checkout Stripe creata",
  "auditLogs.actions.stripe_checkout_session_reused": "Sessione checkout Stripe riutilizzata",
  "auditLogs.actions.stripe_checkout_session_failed": "Creazione sessione checkout Stripe fallita",
  "auditLogs.actions.stripe_webhook_duplicate_ignored": "Evento webhook Stripe duplicato ignorato",
  "auditLogs.actions.stripe_webhook_event_received": "Evento webhook Stripe ricevuto",
  "auditLogs.actions.stripe_webhook_failed": "Elaborazione webhook Stripe fallita",
  "auditLogs.actions.stripe_webhook_signature_invalid": "Firma webhook Stripe non valida",
  "auditLogs.trail.title": "Audit trail globale",
  "auditLogs.trail.subtitle": "Timeline operativa cross-servizio (auth, CMS, catalogo, ordini e Stripe webhook).",
  "auditLogs.trail.loading": "Caricamento audit trail globale...",
  "auditLogs.trail.empty": "Nessun evento trail trovato con i filtri correnti.",
  "auditLogs.trail.errors.load": "Errore recupero audit trail globale",
  "auditLogs.trail.stats.total": "Eventi trail",
  "auditLogs.trail.stats.processed": "Processati",
  "auditLogs.trail.stats.failed": "Falliti",
  "auditLogs.trail.stats.pending": "In attesa",
  "auditLogs.trail.filters.searchLabel": "Ricerca trail",
  "auditLogs.trail.filters.searchPlaceholder": "Cerca per evento, azione, request id, errore...",
  "auditLogs.trail.filters.orderIdLabel": "Order ID",
  "auditLogs.trail.filters.orderIdPlaceholder": "Filtra per orderId",
  "auditLogs.trail.filters.sourceLabel": "Sorgente trail",
  "auditLogs.trail.filters.source.all": "Tutte",
  "auditLogs.trail.filters.source.auth": "Auth service",
  "auditLogs.trail.filters.source.payments": "Pagamenti",
  "auditLogs.trail.filters.source.cms": "CMS",
  "auditLogs.trail.filters.source.catalog": "Catalogo",
  "auditLogs.trail.filters.source.orders": "Ordini",
  "auditLogs.trail.filters.source.webhook": "Stripe webhook",
  "auditLogs.trail.filters.statusLabel": "Stato trail",
  "auditLogs.trail.filters.status.all": "Tutti",
  "auditLogs.trail.table.timestamp": "Timestamp",
  "auditLogs.trail.table.source": "Sorgente",
  "auditLogs.trail.table.service": "Servizio",
  "auditLogs.trail.table.event": "Evento/Azione",
  "auditLogs.trail.table.status": "Stato",
  "auditLogs.trail.table.actor": "Attore",
  "auditLogs.trail.table.order": "Ordine",
  "auditLogs.trail.table.details": "Dettagli",
  "auditLogs.trail.detailsPanel.title": "Dettaglio trail selezionato",
  "auditLogs.trail.detailsPanel.empty": "Seleziona una riga dalla lista trail per approfondire l'evento.",
  "auditLogs.trail.detailsView.subtitle": "Vista dettaglio trail",
  "auditLogs.trail.detailsView.back": "Torna alla lista",
  "auditLogs.trail.related.title": "Eventi correlati",
  "auditLogs.trail.related.empty": "Nessun evento correlato trovato per la selezione corrente.",
  "auditLogs.trail.related.byRequest": "stessa request",
  "auditLogs.trail.related.byEvent": "stesso evento",
  "auditLogs.trail.related.byOrder": "stesso ordine",
  "auditLogs.trail.details.eventId": "Event ID",
  "auditLogs.trail.details.requestId": "Request ID",
  "auditLogs.trail.details.ip": "IP",
  "auditLogs.trail.details.changed": "Campi modificati",
  "auditLogs.trail.details.cleared": "Campi azzerati",
  "auditLogs.trail.details.attempts": "Tentativi",
  "auditLogs.trail.details.duplicates": "Duplicati",
  "auditLogs.trail.details.reason": "Motivo",
  "auditLogs.trail.status.received": "Ricevuto",
  "auditLogs.trail.status.processed": "Processato",
  "auditLogs.trail.status.ignored": "Ignorato",
  "auditLogs.trail.status.failed": "Fallito",
  "auditLogs.trail.status.success": "Successo",
  "auditLogs.trail.status.failure": "Errore",
  "auditLogs.trail.status.denied": "Negato",
  "auditLogs.trail.status.unknown": "Sconosciuto",
  "auditLogs.trail.source.auth": "Auth",
  "auditLogs.trail.source.payments": "Pagamenti",
  "auditLogs.trail.source.cms": "CMS",
  "auditLogs.trail.source.catalog": "Catalogo",
  "auditLogs.trail.source.orders": "Ordini",
  "auditLogs.trail.source.webhook": "Stripe webhook",
  "auditLogs.trail.source.unknown": "Sconosciuta"
}

export default auditLogsMessages
